import  ks from "../ReUsableTS/kalmstromShared4";
export class kRequest{

    public URL: string = "";
    public Method: string = "GET";
    public Data: any = null;
    public ContentType: string = "application/json; charset=utf-8";
    public DataType: string = "json";
    public SuccessCB: any = null;
    public ErrorCB: any = null;
   
    public Headers: string [] = [];
    public Timeout: number = 0;
    public XHR: XMLHttpRequest = new XMLHttpRequest();
    public Call = (URL:string,Method?:string,Callback?:any): void => {
        if (ks.kErrorMode === true) { return; }
        try {
            this.URL = URL;
            if(Method){
                this.Method = Method;
            }
            if(Callback){
                this.SuccessCB = Callback;
            }
            this._Call();
        } catch (e) {ks.kGlobalErrorHandler(e, "kContextMenu.Call");}
    }
    private _Call = (): void => {
        if (ks.kErrorMode === true) { return; }
        try {
            const XMLReq:XMLHttpRequest = new XMLHttpRequest();
            XMLReq.open(this.Method, this.URL);
            XMLReq.setRequestHeader("Content-Type", this.ContentType);
            if (this.Headers) {
                for (const key in this.Headers) {
                    if (this.Headers.hasOwnProperty(key)) {
                        XMLReq.setRequestHeader(key, this.Headers[key]);
                    }
                }
            }
            if (this.Timeout > 0) {
                XMLReq.timeout = this.Timeout;
            }
            XMLReq.onload = this._OnLoad;
            XMLReq.onerror = this._OnError;
            XMLReq.ontimeout = this._OnTimeOut;
            this.XHR = XMLReq;
            this.XHR.send(this.Data);
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kAjax._Call");
        }
    }
    private _OnLoad = (): void => {
        // if (ks.kErrorMode === true) { return; } //Disabled for error reporting
        // try {
            if (this.XHR.status >= 200 && this.XHR.status < 300) {
                if (this.SuccessCB) {
                    if (this.DataType === "json") {
                        this.SuccessCB(JSON.parse(this.XHR.responseText));
                    } else {
                        this.SuccessCB(this.XHR.responseText);
                    }
                }
            } else {
                if (this.ErrorCB) {
                    this.ErrorCB(this.XHR.statusText);
                }
            }
        // } catch (e) {
        //     ks.kGlobalErrorHandler(e, "kAjax._OnLoad");
        // }
    }
    private _OnError = (): void => {
        if (ks.kErrorMode === true) { return; }
        try {
            if (this.ErrorCB) {
                this.ErrorCB(this.XHR.statusText);
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kAjax._OnError");
        }
    }
    private _OnTimeOut = (): void => {
        if (ks.kErrorMode === true) { return; }
        try {
            if (this.ErrorCB) {
                this.ErrorCB("Timeout");
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kAjax._OnError");
        }
    }
}

